import {
  useDeleteMaterial as useDomainDeleteMaterial,
  Material,
  MaterialsQueryKey,
  MaterialWithRecipesQueryKey,
  MaterialsRecipesQueryKey
} from '@domain/materials'
import {useNotification} from '@hconnect/uikit/src/common'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {settingsQueryClient} from '../../../../modules/common/providers'
import {
  invalidateSettingsQuery,
  removeSettingsQuery
} from '../../../../modules/common/providers/ApiInterface'
import {notifyIfErrorMessage} from '../../../../modules/common/utils/errorHandling'
import {ErrorResponse} from '../../../common/types'

export const useDeleteMaterial = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()
  return useDomainDeleteMaterial({
    onError: (error) => {
      notifyIfErrorMessage(
        (error.response?.data as ErrorResponse | undefined)?.detail,
        raiseError,
        notify
      )
    },
    onSuccess: (data, variables) => {
      notify('success', t('success.deleteMaterial'))
      const prevMaterials = settingsQueryClient.getQueryData<Material[]>([
        MaterialsQueryKey,
        variables.plantCode
      ])
      if (prevMaterials) {
        void settingsQueryClient.setQueryData(
          [MaterialsQueryKey, variables.plantCode],
          prevMaterials.filter((material) => material.id !== variables.materialId)
        )
      }
      // removing deleted material from materialWithRecipes query
      settingsQueryClient.removeQueries({
        queryKey: [MaterialWithRecipesQueryKey, variables.plantCode, variables.materialId]
      })
      // invalidating all materials with recipes, because we need remove the material from all recipe ingredients
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialWithRecipesQueryKey],
        refetchType: 'all'
      })
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialsRecipesQueryKey],
        refetchType: 'all'
      })
      // assets could have attached recipe which belong to deleted material
      invalidateSettingsQuery('assets')
      removeSettingsQuery('schedule')
    }
  })
}
